import React from 'react';

const NosotrosPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-slate-800 to-gray-900">
      {/* Navigation */}
      <nav className="bg-black/80 backdrop-blur-md border-b-2 border-gradient-to-r from-yellow-400 via-orange-500 to-yellow-400">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <div className="flex items-center space-x-3 ml-0">
              <div className="bg-black/20 backdrop-blur-sm rounded-xl p-1 border border-yellow-400/30">
                <img 
                  src="https://static.readdy.ai/image/f83f5cd629da4d80734129e80e4e4145/4a7f8b54088d811b1f1eaf12115718e6.jpeg" 
                  alt="ESPECTÁCULOS BRONCHÚ Logo" 
                  className="h-14 w-14 rounded-lg shadow-lg object-cover"
                />
              </div>
              <div>
                <h1 className="text-xl font-black text-white font-sans tracking-widest drop-shadow-2xl" style={{fontFamily: 'Inter, system-ui, sans-serif', letterSpacing: '0.2em', textShadow: '2px 2px 4px rgba(0,0,0,0.8)'}}>
                  ESPECTÁCULOS BRONCHÚ
                </h1>
                <p className="text-xs text-yellow-400 font-light tracking-widest" style={{letterSpacing: '0.25em'}}>
                  L'ART DEL FOC I EL SO
                </p>
              </div>
            </div>

            {/* Navigation Menu */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="/" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                INICIO
              </a>
              <a href="/pirotecnica" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                FUEGOS ARTIFICIALES
              </a>
              <a href="/eventos" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                EVENTOS
              </a>
              <a href="/videos" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                VIDEOS
              </a>
              <a href="/calendario" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                CALENDARIO
              </a>
              <a href="/merchandising" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                MERCHANDISING
              </a>
              <a href="/nosotros" className="text-yellow-400 border-b-2 border-yellow-400 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                NOSOTROS
              </a>
              <a href="/contacto" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                CONTACTO
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative py-20">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=traditional%20Spanish%20family%20business%20workshop%20with%20fireworks%20and%20pyrotechnics%20equipment%2C%20multi-generational%20family%20working%20together%2C%20traditional%20craftsmanship%2C%20Godella%20Valencia%2C%20family%20heritage%20and%20tradition&width=1920&height=600&seq=nosotros1&orientation=landscape')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-gray-900/60 to-gray-800/40"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <div className="bg-red-500 text-white px-4 py-2 rounded-full text-sm font-bold mb-6 inline-block">
            EMPRESA FAMILIAR DESDE 2008
          </div>
          <h1 className="text-6xl md:text-7xl font-bold text-white mb-6 tracking-wider drop-shadow-2xl">
            NUESTRA
            <span className="block bg-gradient-to-r from-orange-400 via-yellow-400 to-red-500 bg-clip-text text-transparent">
              FAMILIA
            </span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            17 años de tradición familiar en el arte de la pirotécnica y el espectáculo
          </p>
        </div>
      </section>

      {/* Nuestra Historia */}
      <section className="py-20 bg-gradient-to-b from-slate-800 to-slate-700">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Imagen */}
            <div className="order-2 lg:order-1">
              <div 
                className="h-96 bg-cover bg-center rounded-2xl shadow-2xl"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=traditional%20family%20mascleta%20miniature%20fireworks%20display%20in%20Godella%20Valencia%2C%20Spanish%20family%20tradition%2C%20artisan%20craftsmanship%2C%20traditional%20pyrotechnics%20workshop%2C%20heritage%20celebration&width=600&height=400&seq=24&orientation=landscape')`
                }}
              >
                <div className="h-full bg-gradient-to-t from-black/60 via-transparent to-transparent rounded-2xl flex items-end">
                  <div className="p-8">
                    <div className="bg-yellow-400 text-black px-4 py-2 rounded-lg font-bold text-sm tracking-wider inline-block">
                      GODELLA, VALENCIA
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Contenido */}
            <div className="order-1 lg:order-2">
              <h2 className="text-5xl font-serif font-bold text-white mb-8 tracking-wider">
                NUESTRA HISTORIA
              </h2>
              
              <div className="space-y-6 text-gray-300 leading-relaxed">
                <p className="text-lg">
                  <strong className="text-yellow-400">ESPECTÁCULOS BRONCHÚ</strong>, es una empresa familiar creada en 2008 con la intención de facilitar en lo posible la organización, el trabajo y sacrificio que conlleva la realización de una fiesta, tanto de ámbito local como en cualquier otro.
                </p>
                
                <p>
                  Conocedora de las artes pirotécnicas antiguas, modernas e intentando evolucionar en este mundo, nace para abarcar todo tipo de espectáculos relacionados con la fiesta, tanto tradicional como moderna.
                </p>
                
                <p>
                  Durante este tiempo y pasar por diferentes fases nos hemos <strong className="text-orange-400">especializado en el diseño y producción de eventos tanto de fuegos artificiales como musicales</strong>.
                </p>
                
                <p>
                  <strong className="text-red-400">El producto que más nos representa son nuestras mascletas en miniatura pensadas para ofrecer un gran espectáculo en espacios reducidos</strong>.
                </p>
                
                <p>
                  Ofrecemos una amplia gama de servicios pirotécnicos adaptados a todo tipo de celebraciones: desde bodas íntimas hasta grandes eventos municipales. Nuestro equipo combina técnicas tradicionales valencianas con las últimas innovaciones en pirotecnia, garantizando espectáculos seguros y memorables.
                </p>
                
                <p>
                  Trabajamos estrechamente con nuestros clientes desde la conceptualización hasta la ejecución, asegurándonos de que cada evento refleje la visión y el presupuesto deseado. La personalización es clave en nuestro servicio: cada espectáculo es único y diseñado específicamente para la ocasión.
                </p>
                
                <p>
                  Además de la pirotecnia, integramos elementos musicales y efectos especiales que complementan perfectamente nuestros espectáculos de fuegos artificiales, creando experiencias sensoriales completas que cautivan a audiencias de todas las edades.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Valores */}
      <section className="py-20 bg-gradient-to-b from-slate-700 to-gray-700">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-serif font-bold text-white mb-6 tracking-wider">
              NUESTROS VALORES
            </h2>
            <p className="text-xl text-gray-300">
              Los pilares que nos definen desde 2008
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center group">
              <div className="bg-gradient-to-r from-orange-500 to-yellow-400 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-shield-check-line text-white text-3xl"></i>
              </div>
              <h3 className="text-white text-xl font-bold mb-4 tracking-wider">SEGURIDAD</h3>
              <p className="text-gray-300 text-sm leading-relaxed">
                Cumplimos con todas las normativas de seguridad. Cada espectáculo está completamente asegurado y supervisado por profesionales.
              </p>
            </div>

            <div className="text-center group">
              <div className="bg-gradient-to-r from-pink-500 to-red-500 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-heart-line text-white text-3xl"></i>
              </div>
              <h3 className="text-white text-xl font-bold mb-4 tracking-wider">PASIÓN</h3>
              <p className="text-gray-300 text-sm leading-relaxed">
                17 años haciendo lo que más nos gusta. Cada evento es una nueva oportunidad para crear algo mágico y único.
              </p>
            </div>

            <div className="text-center group">
              <div className="bg-gradient-to-r from-green-500 to-cyan-500 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-lightbulb-line text-white text-3xl"></i>
              </div>
              <h3 className="text-white text-xl font-bold mb-4 tracking-wider">INNOVACIÓN</h3>
              <p className="text-gray-300 text-sm leading-relaxed">
                Incorporamos constantemente nuevas técnicas y tecnologías para ofrecer espectáculos cada vez más impresionantes.
              </p>
            </div>

            <div className="text-center group">
              <div className="bg-gradient-to-r from-purple-500 to-pink-500 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-star-line text-white text-3xl"></i>
              </div>
              <h3 className="text-white text-xl font-bold mb-4 tracking-wider">EXCELENCIA</h3>
              <p className="text-gray-300 text-sm leading-relaxed">
                Cada detalle cuenta. Desde la planificación hasta la ejecución, buscamos la perfección en cada proyecto.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-32">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=spectacular%20fireworks%20team%20celebration%20after%20successful%20show%2C%20professional%20pyrotechnics%20experts%20celebrating%2C%20Valencia%20Spain%20night%20sky%2C%20golden%20sparks%20background%2C%20team%20spirit%20and%20joy%2C%20cinematic%20wide%20shot&width=1920&height=800&seq=100&orientation=landscape')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-gray-900/60 to-gray-800/50"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <h2 className="text-6xl md:text-7xl font-bold text-white mb-8 tracking-wider drop-shadow-2xl">
            ¿HABLAMOS?
          </h2>
          <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto leading-relaxed">
            Estaremos encantados de conocerte y hacer realidad el espectáculo de tus sueños
          </p>
          <div className="flex flex-col lg:flex-row items-center justify-center space-y-4 lg:space-y-0 lg:space-x-8">
            <a href="/contacto" className="bg-white text-black px-12 py-6 rounded-full font-bold text-xl tracking-wider hover:scale-105 transition-transform duration-300 flex items-center space-x-4 cursor-pointer whitespace-nowrap">
              <span>CONTÁCTANOS</span>
              <div className="bg-black text-white w-12 h-12 rounded-full flex items-center justify-center">
                <i className="ri-message-3-line text-xl"></i>
              </div>
            </a>
            <div className="text-white text-center lg:text-right">
              <div className="text-lg font-light tracking-wider leading-relaxed">
                RESPUESTA EN MENOS DE 24H
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-t from-slate-800 to-gray-700 py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-12">
            {/* Logo y Descripción */}
            <div className="lg:col-span-2">
              <h3 className="text-white text-2xl font-serif font-bold mb-4">
                ESPECTÁCULOS BRONCHÚ
                <span className="text-yellow-400 text-lg">.</span>
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Especialistas en mascletas en miniatura con más de 17 años de experiencia creando momentos únicos e inolvidables.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="border-2 border-yellow-400 text-yellow-400 w-10 h-10 rounded-lg flex items-center justify-center hover:bg-yellow-400 hover:text-black transition-all duration-300 cursor-pointer">
                  <i className="ri-facebook-line"></i>
                </a>
                <a href="#" className="border-2 border-yellow-400 text-yellow-400 w-10 h-10 rounded-lg flex items-center justify-center hover:bg-yellow-400 hover:text-black transition-all duration-300 cursor-pointer">
                  <i className="ri-instagram-line"></i>
                </a>
                <a href="#" className="border-2 border-yellow-400 text-yellow-400 w-10 h-10 rounded-lg flex items-center justify-center hover:bg-yellow-400 hover:text-black transition-all duration-300 cursor-pointer">
                  <i className="ri-youtube-line"></i>
                </a>
              </div>
            </div>

            {/* Enlaces Rápidos */}
            <div>
              <h4 className="text-white font-bold text-lg mb-6 tracking-wider">SERVICIOS</h4>
              <ul className="space-y-3">
                <li><a href="/pirotecnica" className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 cursor-pointer">FUEGOS ARTIFICIALES</a></li>
                <li><a href="/eventos" className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 cursor-pointer">EVENTOS</a></li>
                <li><a href="/videos" className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 cursor-pointer">GALERÍA</a></li>
                <li><a href="/calendario" className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 cursor-pointer">CALENDARIO</a></li>
              </ul>
            </div>

            {/* Contacto */}
            <div>
              <h4 className="text-white font-bold text-lg mb-6 tracking-wider">CONTACTO</h4>
              <ul className="space-y-3">
                <li className="text-gray-300">693 812 675</li>
                <li className="text-gray-300">info@espectaculosbronchu.es</li>
                <li className="text-gray-300">VALENCIA, ESPAÑA</li>
                <li><a href="/contacto" className="text-yellow-400 hover:underline cursor-pointer">SOLICITAR PRESUPUESTO</a></li>
              </ul>
            </div>
          </div>

          {/* Bottom Footer */}
          <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col lg:flex-row items-center justify-between">
            <p className="text-gray-400 text-sm mb-4 lg:mb-0">
              © 2025 ESPECTÁCULOS BRONCHÚ. TODOS LOS DERECHOS RESERVADOS
            </p>
            
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 text-sm hover:text-yellow-400 transition-colors duration-300 cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default NosotrosPage;